const theme = {
  token: {
    // Primary colors
    colorPrimary: '#EE6C4D',
    colorInfo: '#1A73E8',
    colorSuccess: '#4CAF50',
    colorWarning: '#fb8c00',
    colorError: '#F44335',

    // Font
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,

    // Border
    borderRadius: 8,

    // Layout
    colorBgLayout: '#f0f2f5',
    colorBgContainer: '#ffffff',

    // Text
    colorText: '#344767',
    colorTextSecondary: '#7b809a',
    colorTextTertiary: '#a0a0a0',

    // Control
    controlHeight: 40,
    controlHeightLG: 48,
    controlHeightSM: 32,
  },
  components: {
    Button: {
      controlHeight: 40,
      fontWeight: 500,
      primaryShadow: 'none',
    },
    Input: {
      controlHeight: 40,
    },
    Select: {
      controlHeight: 40,
    },
    Table: {
      borderRadius: 8,
      headerBg: '#fafafa',
      headerColor: '#344767',
    },
    Card: {
      borderRadiusLG: 8,
      boxShadowTertiary: '0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)',
    },
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#344767',
      bodyBg: '#f0f2f5',
    },
    Menu: {
      darkItemBg: '#344767',
      darkItemSelectedBg: '#2A3A56',
      darkItemHoverBg: '#2A3A56',
    },
  },
};

export default theme;
